export default __webpack_public_path__ + "static/media/customers.cbb36346.svg";